import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ae22ad2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "legend-container" }
const _hoisted_2 = ["src"]

import { ref, watchEffect } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageLegend',
  props: {
  url: {
    type: String,
    required: true,
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;



const dataUrl = ref<any>('');

watchEffect(() => {
  if (props.url) {
    // https://xxx.com/aaaa to /proxy/https/xxx.com/aaaa
    // http://xxx.com/aaaa to /proxy/http/xxx.com/aaaa
    const regex = /^(https?):\/\/(.+)$/;
    const match = props.url.match(regex);
    if (match) {
      const protocol = match[1];
      const rest = match[2];
      const url = `/proxy/${protocol}/${rest}`;
      dataUrl.value = url;
    } else {
      dataUrl.value = props.url;
    }
  }
});


return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_el_text, {
      tab: "b",
      size: "large"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('legend')), 1)
      ]),
      _: 1
    }, 512), [
      [_vShow, __props.showTitle]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([{ 'export-legend': __props.showTitle }, "legend-wrap"])
    }, [
      (__props.url)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: dataUrl.value,
            class: "raster-legend"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true)
    ], 2),
    _withDirectives(_createVNode(_component_el_empty, {
      description: _ctx.$t('Empty.Legend'),
      "image-size": 80
    }, null, 8, ["description"]), [
      [_vShow, (!__props.url || __props.url.length === 0) && !__props.showTitle]
    ])
  ]))
}
}

})